import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { ShieldAccessListsApiStore, ShieldApiStore } from '@bn/app-shield';
import { CDN_ROUTES } from '@bn/dashboard-core/constants';
import { AppRoutes } from '@bn/dashboard-core/enums';
import { AbstractLazyDirective } from '@bn/shared/entities/abstracts/abstract-lazy.directive';
import { StoreRequest } from '@bn/shared/state-store';

@Component({
  templateUrl: './app-shield-access-lists.page.html',
  styleUrls: ['./app-shield-access-lists.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppShieldAccessListsPage extends AbstractLazyDirective implements OnDestroy {
  readonly #shieldStore = inject(ShieldApiStore);
  readonly #shieldAccessListsStore = inject(ShieldAccessListsApiStore);

  readonly isAdded = this.#shieldAccessListsStore.isFinished(StoreRequest.Add);

  public currentTab!: string;

  constructor() {
    super();

    const pullZoneId = this.#shieldStore.pullZoneId();

    this.contentService.setTitle('Access lists');
    this.contentService.setBackButton({
      routerLink: `/${AppRoutes.CDN}/${pullZoneId}/${AppRoutes.Shield}`,
    });

    // set local variable for parent page to be able to use onRouterOutletLoaded
    this.route.firstChild?.data.subscribe(({ activeTab }) => {
      this.currentTab = activeTab;
    });

    this.subscribeToStoreSignals();
  }

  public ngOnDestroy(): void {
    this.contentService.setBackButton(null);
  }

  private subscribeToStoreSignals(): void {
    toObservable(this.#shieldStore.selectedEntityId())
      .pipe(takeUntilDestroyed())
      .subscribe((shieldZoneId) => {
        if (!shieldZoneId) return;

        this.#shieldAccessListsStore.getAccessLists({
          shieldZoneId: Number(shieldZoneId),
        });
      });

    toObservable(this.isAdded)
      .pipe(takeUntilDestroyed())
      .subscribe((isAdded) => {
        if (!isAdded) return;

        this.router.navigate([`./${CDN_ROUTES.ShieldAccessListsCustom}`], { relativeTo: this.route });
      });
  }
}
